export default "__VITE_ASSET__a0K8mry2__"